<app-loader></app-loader>
<div class="p-g p-g-nopad device-height">
  <app-sidebar role="navigation" class="sidebar p-col-fixed left-panel p-g-nopad"></app-sidebar>
  <div class="main-panel p-col right-panel p-g-nopad">
    <app-header class="top-nav p-g p-g-nopad" role="banner"></app-header>
    <div class="inner-container" role="main" style="overflow-y: auto;height: calc(100vh - 70px);overflow-x: hidden;">
      <app-page-header></app-page-header>
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
